/** @jsx jsx */
import { jsx } from "@emotion/core";
import { Heading } from "@chakra-ui/core";

export default ({ children, ...rest }) => (
  <Heading as="h2" size="lg" fontWeight={400} mb={8} mt={8} {...rest}>
    {children}
  </Heading>
);
